export const PRECISION_FORMATS = {
    days: 'd/M/YYYY',
    months: 'M/YYYY',
    year: 'YYYY',
}
